<div class="container-fluid cw-background">
  <div class="row d-flex justify-content-center">
    <div class="col-12 col-sm-9 col-sm-offset-1 col-md-9 col-md-offset-1 col-lg-7 mt-5 mb-5">
      <mat-card class="mat-elevation-z8" id="card">
        <div class="text-left go-back d-block">
          <button (click)="goBack()" disableRipple mat-button class="delete-user p-0">
            <mat-icon matPreffix>arrow_back_ios</mat-icon>
            Go Back
          </button>

          <h2 class="text-center card-title-page">Location Bulk upload</h2>
        </div>

        <app-csv-download-button [downloadTemplateCallback]="downloadCSV"> </app-csv-download-button>
        <h5 class="mb-4">Add a CSV file to create or update your locations in bulk mode</h5>
        <div class="my-4">
          <h6>Columns</h6>
          <code>name</code>, <code>description</code>, <code>address1</code>, <code>address2</code>,
          <code>address3</code>, <code>city</code>, <code>state</code>, <code>zip</code>, <code>country</code>,
          <code>phone</code>, <code>primaryUser</code>, <code>companyIdentifier</code
          ><span *ngIf="currentUser.isGlobal()">, <code>isStaffManaged</code></span>
        </div>
        <div class="my-4">
          <h6>Column Type</h6>
          <p>name(*): <code>required</code>, <code>unique</code></p>
          <p>description<code>optional</code></p>
          <p>address1(*): <code>required</code></p>
          <p>address2: <code>optional</code></p>
          <p>address3: <code>optional</code></p>
          <p>city: <code>required</code></p>
          <p>state: <code>required</code></p>
          <p>zip: <code>required</code></p>
          <p>country: <code>required</code></p>
          <p>phone: <code>optional</code></p>
          <p>primaryUser: <code>optional</code>, <code>email</code></p>
          <p>
            companyIdentifier(*): <code>required</code>,
            <code>unique</code>
          </p>
          <p *ngIf="currentUser.isGlobal()">isStaffManaged: <code>optional</code></p>
        </div>
        <h6 class="my-4">No comma(,) allowed in data as is used as separator</h6>
        <div class="my-4">
          <h6>Example</h6>
          <div class="csv-code-example py-2 px-3">
            <code>
              name,description,address1,address2,address3,city,state,zip,country,phone,companyIdentifier<span
                *ngIf="currentUser.isGlobal()"
                >,isStaffManaged</span
              ><br />
              M.C. Sales office,Mega Company Sales Office,123 St name,,Norcross,GA,30092,US,,primary@user.com,{{
                getCompanyData()
              }}<span *ngIf="currentUser.isGlobal()">,true</span><br />
            </code>
          </div>
        </div>
        <div class="row d-flex justify-content-center">
          <div class="col-12 col-sm-9 col-sm-offset-1 mt-4">
            <app-dynamic-form [questions]="questions" (formSubmit)="onSubmit($event)" [disabled]="loading">
            </app-dynamic-form>
          </div>
        </div>
      </mat-card>
    </div>
  </div>
</div>
